import ConfirmModal from "components/shared-components/ConfirmModal";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { useActiveTimeSlot, useDeleteTimeSlot, useTimeSlotsV2 } from "hooks";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { Button, Card, CardBody, Col, Row, Label } from "reactstrap";
import { Switch } from "antd";
import BreadcrumbWithLink from "../../components/Common/BreadcrumbWithLink";
import FormTimeslotModal from "./FormModal";
import { useTimeslotCollectorList } from "hooks/timeslot-collector/useTimeslotCollector";
import HubFilter from "components/shared-components/RemoteTable/HubFilter/HubFilter";

const TimeslotCollectorPage = () => {
  const { t } = useTranslation(["timeslotCollector"]);
  const [isOpenModalCreate, setIsOpenModalCreate] = useState(false);
  const [isOpenModalUpdate, setIsOpenModalUpdate] = useState(false);
  const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false);
  const [timeslotIdChoosen, setTimeslotIdChoosen] = useState(undefined);
  const [action, setAction] = useState(undefined);
  const [timeslotUpdate, setTimeslotUpdate] = useState(undefined);
  const [timeSlotParams, setTimeSlotParams] = useState({
    page: 1,
    "per-page": 10,
    expand: "hub",
    run: false,
  });

  const toggleModalCreate = type => {
    setIsOpenModalCreate(prev => (type !== undefined ? type : !prev));
  };

  const toggleModalUpdate = type => {
    if (type !== undefined && !Boolean(type)) {
      setTimeslotUpdate(undefined);
    }
    setIsOpenModalUpdate(prev => (type !== undefined ? type : !prev));
  };

  const {
    data: timeSlotData,
    isLoading: isTimeSlotLoading,
    refetch: fetchTimeSlot,
  } = useTimeslotCollectorList({
    params: timeSlotParams,
  });

  useEffect(() => {
    if (timeSlotParams && timeSlotParams.run) {
      fetchTimeSlot();
    }
  }, [timeSlotParams]);

  const onSearchAllHandle = useCallback(value => {
    setTimeSlotParams(prev => ({
      ...prev,
      keywords: value,
    }));
  }, []);

  const onTableChange = useCallback((_type, value) => {
    setTimeSlotParams(prev => ({
      ...prev,
      page: value.page,
      "per-page": value.sizePerPage,
      sort: `${value.sortOrder}${value.sortField}`,
    }));
  }, []);

  const onSuccessAction = () => {
    fetchTimeSlot();
    setTimeslotIdChoosen(undefined);
    setAction(undefined);
    setIsOpenModalConfirm(false);
  };

  const { mutate: deleteTimeSlot } = useDeleteTimeSlot(onSuccessAction);

  const { mutate: activeTimeSlot } = useActiveTimeSlot(onSuccessAction);

  // const [is_level_2, setIsLevel2] = useState(true);
  // const handleChangeIsLevel2 = value => {
  //   setIsLevel2(value);
  // }

  const columnTable = [
    {
      dataField: "id",
      text: t("table.no"),
      formatter: (cell, row, enumObject) => {
        return `${enumObject + 1}`;
      },
    },
    {
      dataField: "name",
      text: t("table.name"),
      sort: true,
    },
    {
      dataField: "code",
      text: t("table.code"),
      sort: true,
    },
    {
      dataField: "hub_id",
      text: t("table.hub"),
      sort: true,
      formatter: (_cell, row) => {
        return row?.hub?.name;
      },
    },
    {
      dataField: "from_time",
      text: t("table.start_time"),
      sort: true,
    },
    {
      dataField: "to_time",
      text: t("table.end_time"),
      sort: true,
    },
  ];

  const rowActionList = [
    {
      actionAccess: "",
      icon: <i className="fas fa-pen fa-lg text-primary ms-2" />,
      text: t("actions.edit"),
      onClick: row => {
        // navigate(`/hub/${row.id}`);
        setTimeslotUpdate(row);
        toggleModalUpdate();
      },
    },
    {
      actionAccess: "",
      icon: <i className="fas fa-lock fa-lg ms-2 text-danger" />,
      text: t("actions.un_active"),
      conditionVisible: {
        record_status: ["O"],
      },
      onClick: row => {
        setIsOpenModalConfirm(true);
        setTimeslotIdChoosen(row.id);
        setAction("un_active");
      },
    },
    {
      actionAccess: "",
      icon: <i className="fas fa-unlock fa-lg ms-2 text-success" />,
      text: t("actions.active"),
      conditionVisible: {
        record_status: ["C"],
      },
      onClick: row => {
        setIsOpenModalConfirm(true);
        setTimeslotIdChoosen(row.id);
        setAction("active");
      },
    },
  ];

  return (
    <div className="page-content">
      <MetaTags>
        <title>{t("title.manager")}</title>
      </MetaTags>
      <div className="container-fluid">
        <BreadcrumbWithLink
          title={
            t("title.list", { target: t("timeslot") }) +
            ` (${timeSlotData?.meta?.totalCount || 0})`
          }
          breadcrumbItems={[
            { name: t("title.manager") },
            { name: t("title.list", { target: t("timeslot") }) },
          ]}
        />
        <Row>
          <Col>
            <Card>
              <CardBody>
                <RemoteDataTable
                  keyField="id"
                  data={timeSlotData?.items || []}
                  columns={columnTable}
                  listRowAction={rowActionList}
                  loading={isTimeSlotLoading}
                  page={timeSlotData?.meta?.currentPage}
                  onTableChange={onTableChange}
                  isShowRowIndex={false}
                  totalSize={timeSlotData?.meta?.totalCount}
                  searchSticky
                  sizePerPage={timeSlotData?.meta?.perPage}
                  onSearchAllHandle={onSearchAllHandle}
                  // rowEvents={rowEventsHandler}
                >
                  <div className="d-flex flex-row justify-content-start align-items-center gap-2">
                    {/* <div>
                      <Label
                        className="d-flex align-items-center gap-1 mb-0"
                        style={{ cursor: "pointer" }}
                        htmlFor="is_level_2"
                        onClick={() => handleChangeIsLevel2(!is_level_2)}
                      >
                        <Switch
                          checked={is_level_2}
                          onChange={handleChangeIsLevel2}
                        />
                        Địa chỉ 2 cấp
                      </Label>
                    </div> */}
                    <div className="d-flex flex-column flex-sm-wrap flex-sm-row mb-md-0 align-items-baseline gap-2">
                      <HubFilter
                        mainFilterParams={timeSlotParams}
                        setMainFilterParams={setTimeSlotParams}
                        isNotFilterChildHub={true}
                        isHaveAllOption={true}
                        isFilterAllDefault={true}
                        handleChangeHub={hubId => {
                          setTimeSlotParams(prev => ({
                            ...prev,
                            columnFilter: {},
                            page: 1,
                            run: true,
                          }));
                        }}
                        addressLevel={3}
                      />
                    </div>

                    <div className="d-flex align-items-center">
                      {/* <Link
                        to={"/hub/create"}
                        className="btn btn-secondary btn-label"
                      >
                        <i className="fas fa-plus label-icon" />
                        {t("title.create")}
                      </Link> */}
                      <Button
                        size="xs"
                        color="secondary"
                        onClick={() => toggleModalCreate()}
                      >
                        {t("title.create")}
                      </Button>
                    </div>
                  </div>
                </RemoteDataTable>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <FormTimeslotModal
        isOpenModal={isOpenModalCreate}
        toggleModal={toggleModalCreate}
        fetchTimeSlot={fetchTimeSlot}
      />
      <FormTimeslotModal
        isOpenModal={isOpenModalUpdate}
        toggleModal={toggleModalUpdate}
        fetchTimeSlot={fetchTimeSlot}
        timeslotUpdate={timeslotUpdate}
      />
      <ConfirmModal
        isOpen={isOpenModalConfirm}
        titleHeader={
          action === "active"
            ? t("actions.confirmActiveModal.titleActive")
            : t("actions.confirmActiveModal.titleUnActive")
        }
        titleBody={
          action === "active"
            ? t("actions.confirmActiveModal.contentActive")
            : t("actions.confirmActiveModal.contentUnActive")
        }
        onConfirm={
          action === "active"
            ? () => activeTimeSlot(timeslotIdChoosen)
            : () => deleteTimeSlot(timeslotIdChoosen)
        }
        textBtnConfirm={t("actions.confirmActiveModal.confirmBtn")}
        textBtnCancel={t("actions.confirmActiveModal.cancelBtn")}
        toggle={() => setIsOpenModalConfirm(false)}
      />
    </div>
  );
};

export default TimeslotCollectorPage;
